import type { FieldDefinition } from '../data/model';
import type { AttributeRuleCondition, AttributeRuleGroup } from '../rules/model';
import { isAttributeRuleGroupValid, MAX_ATTRIBUTE_RULE_CHILDREN } from '../rules/validation';

export type LayerDisplayFilter = AttributeRuleGroup;

export const MAX_DISPLAY_FILTER_CONDITIONS = MAX_ATTRIBUTE_RULE_CHILDREN;

/**
 * Display Filter intentionally consumes only a flat AND subset of the shared
 * rule language. Nested groups and OR remain future F070 scope.
 */
export function isLayerDisplayFilterValid(
  value: unknown,
  fields: readonly FieldDefinition[],
): value is LayerDisplayFilter {
  return (
    isAttributeRuleGroupValid(value, fields) &&
    value.operator === 'and' &&
    value.children.length <= MAX_DISPLAY_FILTER_CONDITIONS &&
    value.children.every((child): child is AttributeRuleCondition => child.kind === 'condition')
  );
}

export function isOptionalLayerDisplayFilterValid(
  value: unknown,
  fields: readonly FieldDefinition[],
): value is LayerDisplayFilter | null {
  return value === null || isLayerDisplayFilterValid(value, fields);
}
